import {
  createApp
} from 'vue'
import { createPinia } from "pinia";
import App from './App.vue'
import PrimeVue from 'primevue/config';
import '/node_modules/primeflex/primeflex.css';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import VOtpInput from "vue3-otp-input";
import {createI18n} from 'vue-i18n';
import EN from './locale/en.json';
import AR from './locale/ar.json';

import seoMixin from './mixins/seoMixin';
import { setRouteMeta } from './utils/seo.js';
import { checkRouteAddonAccess, LOCK_MESSAGE } from './utils/accessControl.js';

import jQuery from "jquery";
const $ = jQuery;
window.$ = $;


import './assets/css/main.css';
import './assets/css/base.css';
import './assets/css/slick.css';
import 'leaflet/dist/leaflet.css';

//theme
import "primevue/resources/themes/lara-light-indigo/theme.css";

//core
import "primevue/resources/primevue.min.css";

import 'primeicons/primeicons.css';
// import moment from 'moment'

import ToastService from 'primevue/toastservice';

import {
  createRouter,
  createWebHistory
} from 'vue-router'

// Route components are lazy-loaded (see `routes` array below) so each page
// is split into its own chunk instead of bloating the initial app.js bundle.
// import bookingATable from './components/bookATable.vue'
// import reservationReviews from './components/reservationReviews.vue'
// import reservationContact from './components/reservationContact.vue'

// New Reservation Template Components
// import ReservationReserve from './components/Reservation-templates/Morphism-template/ReservationReserve.vue'
// import ReservationReviewMorphism from './components/Reservation-templates/Morphism-template/ReservationReview.vue'

// import ReservationReserveFlexible from './components/Reservation-templates/Flexible-template/ReservationReserve.vue'
// import ReservationReviewFlexible from './components/Reservation-templates/Flexible-template/ReservationReview.vue'
// import ReservationContactFlexible from './components/Reservation-templates/Flexible-template/ReservationContact.vue'

// import ReservationReserveInteractive from './components/Reservation-templates/Interactive-template/ReservationReserve.vue'
// import ReservationReviewInteractive from './components/Reservation-templates/Interactive-template/ReservationReview.vue'

// createApp(App).mount('#app')
const app = createApp(App);

//Components
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Password from 'primevue/password';
import SelectButton from 'primevue/selectbutton';
import Menubar from 'primevue/menubar';
import Carousel from 'primevue/carousel';
import Avatar from 'primevue/avatar';
import Message from 'primevue/message';
import Rating from 'primevue/rating';
import Paginator from 'primevue/paginator';
import Galleria from 'primevue/galleria';
import ProgressBar from 'primevue/progressbar';
import Dialog from 'primevue/dialog';
import Slider from 'primevue/slider';
import Textarea from 'primevue/textarea';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import RadioButton from 'primevue/radiobutton';
import Menu from 'primevue/menu';
import TieredMenu from 'primevue/tieredmenu';
import Calendar from 'primevue/calendar'
import AutoComplete from 'primevue/autocomplete';
import FileUpload from 'primevue/fileupload';
import InputNumber from 'primevue/inputnumber';
import Panel from 'primevue/panel';
import Toast from 'primevue/toast';
import OverlayPanel from 'primevue/overlaypanel';
import Skeleton from 'primevue/skeleton';
import ScrollPanel from 'primevue/scrollpanel';
import ProgressSpinner from 'primevue/progressspinner';

if (localStorage.getItem('amaken_language') == null) {
  localStorage.setItem('amaken_language', 'EN');
}

const currentPath = window.location.pathname;

// Check if the URL contains '/en/' or '/ar/' and update localStorage
if (currentPath.startsWith('/en')) {
    localStorage.setItem('amaken_language', 'EN');
} else if (currentPath.startsWith('/ar')) {
    localStorage.setItem('amaken_language', 'AR');
}


const i18n = createI18n({
  locale : localStorage.getItem('amaken_language'), 
  messages : {
    EN : EN,
    AR : AR
  }
});

const routes = [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './components/HomeView.vue'),
      meta: {
        title: '',
        metaTags: [{
            name: '',
            content: ''
          },
          {
            property: '',
            content: ''
          }
        ]
      }
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: () => import(/* webpackChunkName: "verify-email" */ './components/VerifyEmail.vue'),

    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ './components/UserProfile.vue'),

    },
    {
      path: '/profile-setting',
      name: 'profile-setting',
      component: () => import(/* webpackChunkName: "profile-setting" */ './components/ProfileSetting.vue'),

    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import(/* webpackChunkName: "forgot-password" */ './components/ForgotPassword.vue'),

    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import(/* webpackChunkName: "signin" */ './components/SignIn.vue'),

    },
    {
      path: '/redirect-external-login/:id',
      name: 'redirect-external-login',
      component: () => import(/* webpackChunkName: "redirect-external-login" */ './components/RedirectExternalLogin.vue'),

    },
{
      path: '/places',
      name: 'places',
      component: () => import(/* webpackChunkName: "places" */ './components/PlaceList.vue'),

    },
    {
      path: '/search',
      name: 'search-results',
      component: () => import(/* webpackChunkName: "search-results" */ './components/SearchResultsView.vue'),

    },
    {
      path: '/favorite',
      name: 'favorite',
      component: () => import(/* webpackChunkName: "favorite" */ './components/FavoriteList.vue'),

    },
    {
      path: '/bookings',
      name: 'bookings',
      component: () => import(/* webpackChunkName: "bookings" */ './components/BookingList.vue'),

    },
    {
      path: '/category/:name/:id',
      name: 'category',
      component: () => import(/* webpackChunkName: "category" */ './components/CategoryList.vue'),

    },
    {
      path: '/place/:slug',
      name: 'carousel',
      component: () => import(/* webpackChunkName: "carousel" */ './components/CarouselList.vue'),

    },
    {
      path: '/verifyotp/:id',
      name: 'verifyotp',
      component: () => import(/* webpackChunkName: "verifyotp" */ './components/VerifyOtp.vue'),

    },
    {
      path: '/place-detail-old/:id',
      name: 'place-detail-old',
      component: () => import(/* webpackChunkName: "place-detail-old" */ './components/PlaceDetail.vue'),
    },
    {
      path: '/advertise-wit-us',
      name: 'advertise-with-us',
      component: () => import(/* webpackChunkName: "advertise-with-us" */ './components/AdvertiseWithUs.vue'),

    },
    {
      path: '/about-us',
      name: 'about-us',
      component: () => import(/* webpackChunkName: "about-us" */ './components/AboutUsView.vue'),

    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: () => import(/* webpackChunkName: "terms-and-conditions" */ './components/TermsAndConditionsView.vue'),

    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "privacy-policy" */ './components/PrivacyPolicyView.vue'),

    },
    {
      path: '/become-a-partner',
      name: 'become-a-partner',
      component: () => import(/* webpackChunkName: "become-a-partner" */ './components/BecomeAPartner.vue'),

    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: () => import(/* webpackChunkName: "contact-us" */ './components/ContactUsView.vue'),

    },
    {
      path: '/events',
      name: 'events',
      component: () => import(/* webpackChunkName: "events" */ './components/EventsView.vue'),
    },
    {
      path: '/offers',
      name: 'offers',
      component: () => import(/* webpackChunkName: "offers" */ './components/OffersView.vue'),
    },
    {
      // Backward-compatible URL (optional)
      path: '/digital-menu',
      name: 'digital-menu-landing',
      component: () => import(/* webpackChunkName: "digital-menu" */ './components/DigitalMenuView.vue'),
    },
    {
      path: '/menu/:slug',
      name: 'digital-menu',
      component: () => import(/* webpackChunkName: "digital-menu" */ './components/DigitalMenuView.vue'),
    },
    {
      path: '/offer-detail/:slug',
      name: 'offer-detail',
      component: () => import(/* webpackChunkName: "offer-detail" */ './components/OfferDetail.vue'),
    },
    {
      path: '/place-detail/:slug',
      name: 'place-detail',
      component: () => import(/* webpackChunkName: "place-detail" */ './components/PlaceDetail-v2.vue'),
    },
    {
      path: '/event-detail/:slug',
      name: 'event-detail',
      component: () => import(/* webpackChunkName: "event-detail" */ './components/EventsDetailView.vue'),
    },
    {
      path: '/:slug/booking-details',
      name: 'booking-details',
      component: () => import(/* webpackChunkName: "booking-details" */ './components/bookingDetail.vue'),
    },
    {
      path: '/:slug/booking-seating/',
      name: 'booking-seating',
      component: () => import(/* webpackChunkName: "booking-seating" */ './components/bookingSeating.vue'),
    },
    {
      path: '/:slug/reservation',
      name: 'reservation',
      component: () => import(/* webpackChunkName: "reservation" */ './components/ReservationPage.vue'),//bookingATable,
      meta: { addonRequired: 'online-reservations' },
    },
    {
      path: '/:slug/reservation-summary',
      name: 'reservation-summary',
      component: () => import(/* webpackChunkName: "reservation-summary" */ './components/reservationSummary.vue'),
    },
    {
      path: '/:slug/thank-you',
      name: 'thank-you',
      component: () => import(/* webpackChunkName: "reservation-thank-you" */ './components/reservationThankYou.vue'),
    },
    {
      path: '/:slug/reviews',
      name: 'reviews',
      component: () => import(/* webpackChunkName: "reservation-reviews" */ './components/ReservationReviewPage.vue'),//reservationReviews,
      meta: { addonRequired: 'review-rating' },
    },
    // {
    //   path: '/:slug/reviews11',
    //   name: 'reviews11',
    //   component: reservationReviews,
    // },
    {
      path: '/:slug/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "reservation-contact" */ './components/ReservationContactPage.vue'),//reservationContact,
    },
    // {
    //   path: '/:slug/contact11',
    //   name: 'contact11',
    //   component: reservationContact,
    // },
    {
      path: '/:slug/add-review/:id',
      name: 'add-review',
      component: () => import(/* webpackChunkName: "add-review" */ './components/AddReview.vue'),
    },
    // {
    //   path: '/1/reserve',
    //   name: 'reservation-reserve-1',
    //   component: ReservationReserve,
    // },
    // {
    //   path: '/1/review',
    //   name: 'reservation-review-1',
    //   component: ReservationReviewMorphism,
    // },
    // {
    //   path: '/:slug/flexible-template-reservation',
    //   name: 'flexible-template-reservation',
    //   component: ReservationReserveFlexible,
    // },
    // {
    //   path: '/2/review',
    //   name: 'reservation-review-2',
    //   component: ReservationReviewFlexible,
    // },
    // {
    //   path: '/2/contact',
    //   name: 'reservation-contact-2',
    //   component: ReservationContactFlexible,
    // },
    // {
    //   path: '/3/reserve',
    //   name: 'reservation-reserve-3',
    //   component: ReservationReserveInteractive,
    // },
    // {
    //   path: '/3/review',
    //   name: 'reservation-review-3',
    //   component: ReservationReviewInteractive,
    // },
    {
      path: '/onboarding/cuisines',
      name: 'onboarding-cuisines',
      component: () => import(/* webpackChunkName: "onboarding-cuisines" */ './components/OnboardingCuisines.vue'),
    },
    {
      path: '/onboarding/vibe',
      name: 'onboarding-vibe',
      component: () => import(/* webpackChunkName: "onboarding-vibe" */ './components/OnboardingVibe.vue'),
    },
    {
      path: '/onboarding/complete',
      name: 'onboarding-complete',
      component: () => import(/* webpackChunkName: "onboarding-complete" */ './components/OnboardingComplete.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import(/* webpackChunkName: "not-found" */ './components/NotFoundView.vue'),
    },
  ];

  const localizedRoutes = routes.map(route => ({
    ...route,
    path: `/:lang${route.path}`
  }));


  const router = createRouter({
    history: createWebHistory(),
    routes: localizedRoutes,
    scrollBehavior(to) {
      const scrollToTopRoutes = [
        'home', 'place-detail', 'places', 'search-results', 'profile-setting', 'carousel', 'category',
        'events', 'offers', 'offer-detail', 'terms-and-conditions', 'privacy-policy',
        'favorite', 'bookings', 'become-a-partner', 'contact-us', 'booking-details', 'booking-seating',
        'reservation', 'thank-you', 'reservation-summary', 'add-review', 'reservation-review-1',
        'event-detail', 'digital-menu', 'not-found'
      ];
  
      if (scrollToTopRoutes.includes(to.name)) {
        return { top: 0 };
      }
    }
  });

router.beforeEach((to, from, next) => {
    const DEFAULT_LANG = 'en';
    const VALID_LANGS = ['en', 'ar'];

    const storedLang = (localStorage.getItem('amaken_language') || DEFAULT_LANG).toLowerCase();
    const finalLang = VALID_LANGS.includes(storedLang) ? storedLang : DEFAULT_LANG;

    // If URL already contains valid language → continue
    if (VALID_LANGS.includes(to.params.lang)) {
        // Sync language from URL to localStorage
        const urlLang = to.params.lang.toUpperCase();
        if (localStorage.getItem('amaken_language') !== urlLang) {
            localStorage.setItem('amaken_language', urlLang);
        }
        return next();
    }

    // Prevent redirect loop - only redirect if we're not already on a valid route
    // Don't redirect if coming from browser navigation (from exists and has a name or path)
    if (to.path.startsWith(`/${finalLang}/`)) {
        return next();
    }

    // If coming from a valid route (browser navigation), don't replace history
    // Check if from has a valid path (browser back/forward navigation)
    const isBrowserNavigation = from && (from.name || from.path);
    
    // Only force language prefix on initial load or direct navigation, not on browser back/forward
    // Use replace only if there's no previous route (initial load)
    const shouldReplace = !isBrowserNavigation;
    
    next({
        path: `/${finalLang}${to.path}`,
        query: to.query,
        hash: to.hash,
        replace: shouldReplace
    });
});

// Plan/addon access gate — runs after the language guard has resolved `to.params.slug`.
// Pro restaurants always pass; Freemium restaurants must own the addon required by the target
// route's `meta.addonRequired` (set per-route above). Blocked navigations carry the lock message
// via `to.meta.locked` / `to.meta.lockMessage`, which the page component reads to render <FeatureLocked>
// instead of fetching widget customization — this guarantees the addon-lock message always takes
// priority over the "widget not configured" message (the page never gets a chance to check the latter).
router.beforeEach(async (to, from, next) => {
    const result = await checkRouteAddonAccess(to);
    to.meta.locked = !result.allowed;
    to.meta.lockMessage = result.allowed ? null : (result.message || LOCK_MESSAGE);
    next();
});

// After navigation: sync language/direction AND reset page meta for non-place-detail routes.
// place-detail is excluded because PlaceDetail-v2.vue sets richer meta after its API call.
router.afterEach((to) => {
    const lang = to.params.lang;
    if (lang) {
        const langUpper = lang.toUpperCase();
        localStorage.setItem('amaken_language', langUpper);

        const body = document.body;
        if (lang === 'ar') {
            body.classList.add('direction-rtl');
        } else {
            body.classList.remove('direction-rtl');
        }
    }

    // Reset title / meta / JSON-LD for every route except place-detail
    // (place-detail overrides these itself once its API data is ready)
    const routeName = to.name || '';
    if (routeName !== 'place-detail') {
        const langKey = (to.params.lang || localStorage.getItem('amaken_language') || 'EN').toUpperCase();
        setRouteMeta(routeName, langKey);
    }
});
  
  
app.component('button-prime', Button);
app.component('dropdown-prime', Dropdown);
app.component('inputText-prime', InputText);
app.component('checkbox-prime', Checkbox);
app.component('password-prime', Password);
app.component('selectButton-prime', SelectButton);
app.component('menubar-prime', Menubar);
app.component('carousel-prime', Carousel);
app.component('avatar-prime', Avatar);
app.component('rating-prime', Rating);
app.component('paginator-prime', Paginator);
app.component('galleria-prime', Galleria);
app.component('progressBar-prime', ProgressBar);
app.component('dialog-prime', Dialog);
app.component('slider-prime', Slider);
app.component('textarea-prime', Textarea);
app.component('tabView-prime', TabView);
app.component('tabPanel-prime', TabPanel);
app.component('radioButton-prime', RadioButton);
app.component('menu-prime', Menu);
app.component('tieredMenu-prime', TieredMenu);
app.component('message-prime', Message);
app.component('calendar-prime', Calendar);
app.component('toast-prime', Toast);
app.component('OverlayPanel-prime', OverlayPanel);
app.component('Skeleton-prime', Skeleton);
app.component('autoComplete-prime', AutoComplete);
app.component('fileupload-prime', FileUpload);
app.component('panel-prime', Panel);
app.component('inputnumber-prime', InputNumber);
app.component('ScrollPanel-prime', ScrollPanel);
app.component('ProgressSpinner-prime', ProgressSpinner);
app.component('v-otp-input', VOtpInput);
app.use(PrimeVue);
app.use(router);
// app.use(moment);
app.use(VueTelInput);
app.use(ToastService);
app.mixin(seoMixin);
app.use(i18n);
app.use(createPinia());

router.afterEach((to) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-08NTWC3EN4', { 'page_path': to.path });
  }
});

app.config.globalProperties.reservation_average_time = 10;
app.config.globalProperties.table_seating_time = 10;
app.config.globalProperties.amaken_language = localStorage.getItem('amaken_language');
app.config.globalProperties.external_login_facebook = (location.host == '127.0.0.1:8080' || location.host == 'localhost:8080' ? 'http://amaken.test/api/auth/facebook' : 'https://admin.amakenapp.com/api/auth/facebook');
app.config.globalProperties.external_login_google = (location.host == '127.0.0.1:8080' || location.host == 'localhost:8080' ? 'http://amaken.test/api/auth/google' : 'https://admin.amakenapp.com/api/auth/google');
app.config.globalProperties.api_url = (location.host == '127.0.0.1:8080' || location.host == 'localhost:8080' ? 'http://amaken.test/api/' : 'https://admin.amakenapp.com/api/');
// app.config.globalProperties.api_url = 'https://admin.amakenapp.com/api/';
// app.config.globalProperties.api_url = 'http://127.0.0.1:8000/api/';
// app.config.globalProperties.api_url = 'http://amaken.test/api/';

app.config.globalProperties.records_per_page = 12;

app.mount('#app');